module.exports = {
      id: "premium-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#premium",
      toString: function () {
        return this.url;
      }
    }